<script>
import ButtonCircular from '../ButtonCircular.svelte'
import CircularIndicator from '../CircularIndicator.svelte'
import { createEventDispatcher } from "svelte";
    
const dispatch = createEventDispatcher();

export let LIQUIDADOS = null

let w
let h

const _handleClickEvent = (OPCION) => {
    dispatch("click",{opcion : OPCION})
}

</script>


<div class="option-container d-flex flex-column align-items-center justify-content-center text-center mx-1 position-relative" style="max-width: 300px;">
    <div style="width: 200px;height:200px;" bind:clientWidth={w} bind:clientHeight={h}>
        {#if LIQUIDADOS }
            <CircularIndicator porc={LIQUIDADOS.porc_liquidados} {w} {h} lineWidth={20} label="Liquidados">
                <div class="buttons">
                    <ButtonCircular
                        {w} {h} n={1} title={"Ejecutar Liquidación" } on:click={() =>_handleClickEvent("AVANCE-EXEC")}
                    >
                        <ion-icon name="play-outline"></ion-icon>
                    </ButtonCircular>
                    <ButtonCircular
                        {w} {h} n={2} title={"Mostrar Listado / PDF"} on:click={() =>_handleClickEvent("AVANCE-LISTADO")}
                    >
                        <ion-icon name="list-outline"></ion-icon>
                    </ButtonCircular>
                </div>
            </CircularIndicator>
        {:else}
            <CircularIndicator porc={0} {w} {h} lineWidth={20} label="Liquidados"/>
            <div class="buttons">
                <ButtonCircular
                    {w} {h} n={1} title={"Ejecutar Liquidación" } on:click={() =>_handleClickEvent("AVANCE-EXEC")}
                >
                    <ion-icon name="play-outline"></ion-icon>
                </ButtonCircular>
                <ButtonCircular
                    {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("AVANCE-LISTADO")}
                >
                    <ion-icon name="list-outline"></ion-icon>
                </ButtonCircular>
            </div>
        {/if}
    </div>
    <span class="title-desc">Avance del Periodo</span>
    <p style="color:#00000055">Actualmente se encuentran <strong>{LIQUIDADOS ? LIQUIDADOS.cant_liquidados : 0}</strong> liquidaciones de un total de <strong>{LIQUIDADOS ? LIQUIDADOS.cant_total : 0}</strong> suscriptores disponibles.</p>
    
</div>

<style>
    .title-desc {
        margin-top: 10px;
        color: #34495e;
        font-size: 1.5em;
        font-weight: bold;
    }

    ion-icon  {
        pointer-events: none;
    }

    .buttons {
        opacity: 0;
        transition: opacity 500ms;
    }
    
    .option-container:hover .buttons {
        display: flex;
        opacity: 1;
    }

</style>